<section
  id="faq"
  class="relative overflow-hidden py-24 px-6 lg:px-12"
  style="background: var(--theme-bg)"
  aria-label="FAQ"
  *transloco="let t"
>
  <div class="dot-accent-tr" aria-hidden="true"></div>

  <div class="max-w-3xl mx-auto">
    <div class="text-center mb-14">
      <div class="section-label justify-center reveal">FAQ</div>
      <h2
        class="font-display font-bold reveal stagger-1"
        style="font-size:clamp(1.75rem,4vw,2.75rem);letter-spacing:-0.025em"
      >
        Common Questions
      </h2>
    </div>

    <div class="space-y-3">
      @for (faq of faqItems; track $index) {
        <app-faq
          [question]="t(faq.question)"
          [answer]="t(faq.answer)"
          [src]="faq.src ?? ''"
          [isExpanded]="expandedIndex"
          [index]="$index"
          (toggled)="onToggle($index)"
          class="reveal block"
          [class]="'stagger-' + ($index + 1)"
        />
      }
    </div>
  </div>
</section>
